// React Imports
import React, { Component } from "react";

// My Imports
import "../assets/css/bvb.scss"


export default class Header extends Component {
    render() {
        return <div className="row">
            <div className="text-center ">
                <div className="title-header">
                    <a href="/">
                        Portraits with Pastels
                    </a>
                </div>

                <nav className="mingles-nav">
                    <a href="/">portfolio</a>
                    <a href="/about">about</a>
                </nav>
            </div>
        </div>;
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/Header.js
 **/